<template>
    <div class="pagination-wrapper">
        <div class="pagination">
            <!-- 上一页按钮 -->
            <div class="page-btn" :class="{ disabled: currentPage === 1 }"
                @click="currentPage > 1 && handlePageChange(currentPage - 1)">
                <i class="el-icon-arrow-left" />
            </div>

            <!-- 页码列表 -->
            <div class="page-numbers">
                <div v-for="(page, index) in displayPages" :key="index" class="page-num" :class="{
                    active: currentPage === page,
                    dots: page === '...'
                }" @click="page !== '...' && handlePageChange(page)">
                    {{ page }}
                </div>
            </div>

            <!-- 下一页按钮 -->
            <div class="page-btn" :class="{ disabled: currentPage === totalPages }"
                @click="currentPage < totalPages && handlePageChange(currentPage + 1)">
                <i class="el-icon-arrow-right" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PaginationView',
    props: {
        // 当前页码
        currentPage: {
            type: Number,
            default: 1
        },
        // 总页数
        totalPages: {
            type: Number,
            default: 1
        },
        // 最大显示页码数
        maxVisible: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {

        }
    },
    computed: {
        displayPages() {
            const pages = []
            const maxVisible = this.maxVisible
            const half = Math.floor(maxVisible / 2)
            let start = Math.max(1, this.currentPage - half)
            let end = Math.min(this.totalPages, start + maxVisible - 1)

            if (end - start + 1 < maxVisible) {
                start = Math.max(1, end - maxVisible + 1)
            }

            if (start > 1) {
                pages.push(1)
                if (start > 2) pages.push('...')
            }

            for (let i = start; i <= end; i++) {
                pages.push(i)
            }

            if (end < this.totalPages) {
                if (end < this.totalPages - 1) pages.push('...')
                pages.push(this.totalPages)
            }

            return pages
        }
    },
    methods: {
        handlePageChange(page) {
            if (page !== this.currentPage && page >= 1 && page <= this.totalPages) {
                this.$emit('update:currentPage', page)
                this.$emit('change', page)
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.pagination-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    margin-top: 1.5rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    flex-wrap: wrap;

    .pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;

        .page-btn {
            width: 36px;
            height: 36px;
            background: rgba(255, 255, 255, 0.05);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s;
            color: #94a3b8;

            &:hover:not(.disabled) {
                background: rgba(255, 255, 255, 0.1);
                color: #f1f5f9;
                transform: translateY(-2px);
            }

            &.disabled {
                opacity: 0.3;
                cursor: not-allowed;

                &:hover {
                    transform: none;
                }
            }
        }

        .page-numbers {
            display: flex;
            gap: 0.25rem;

            .page-num {
                min-width: 36px;
                height: 36px;
                background: rgba(255, 255, 255, 0.05);
                border: 1px solid rgba(255, 255, 255, 0.1);
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.3s;
                color: #94a3b8;
                font-size: 0.875rem;
                padding: 0 0.5rem;

                &:hover:not(.dots) {
                    background: rgba(255, 255, 255, 0.1);
                    color: #f1f5f9;
                    transform: translateY(-2px);
                }

                &.active {
                    background: linear-gradient(135deg, #6366f1, #a855f7);
                    border-color: transparent;
                    color: white;
                }

                &.dots {
                    cursor: default;
                    background: transparent;
                    border: none;

                    &:hover {
                        background: transparent;
                        color: #94a3b8;
                        transform: none;
                    }
                }
            }
        }
    }
}

// 响应式
@media (max-width: 768px) {
    .pagination-wrapper {
        flex-direction: column;
        gap: 1rem;
    }
}
</style>